// Модуль для управления личными адресами доставки

// Ключ оставлен только для ссылок в старом коде
const PERSONAL_ADDRESSES_KEY = 'personal_delivery_addresses';

function ensureOrderState() {
    if (!window.__orderState) {
        window.__orderState = { cdekSelectedAddresses: [], personalAddresses: [] };
    } else {
        if (!Array.isArray(window.__orderState.cdekSelectedAddresses)) {
            window.__orderState.cdekSelectedAddresses = [];
        }
        if (!Array.isArray(window.__orderState.personalAddresses)) {
            window.__orderState.personalAddresses = [];
        }
    }
}

// Функция для получения сохраненных личных адресов
function getPersonalAddresses() {
    try {
        ensureOrderState();
        return [...window.__orderState.personalAddresses];
    } catch (error) {
        console.error('Ошибка при получении личных адресов:', error);
        return [];
    }
}

// Функция для сохранения личного адреса
function savePersonalAddress(addressData) {
    try {
        const addresses = getPersonalAddresses();
        
        // Проверяем, не существует ли уже такой адрес
        const existingIndex = addresses.findIndex(addr => 
            addr.city === addressData.city && 
            addr.street === addressData.street && 
            addr.house === addressData.house
        );
        
        if (existingIndex !== -1) {
            // Обновляем существующий адрес
            addresses[existingIndex] = {
                ...addresses[existingIndex],
                ...addressData,
                updatedAt: new Date().toISOString()
            };
            console.log('✅ Личный адрес обновлен');
        } else {
            // Добавляем новый адрес
            addresses.push({
                ...addressData,
                id: `personal-${Date.now()}`,
                createdAt: new Date().toISOString(),
                type: 'personal'
            });
            console.log('✅ Новый личный адрес добавлен');
        }
        
        ensureOrderState();
        window.__orderState.personalAddresses = addresses;
        return true;
    } catch (error) {
        console.error('Ошибка при сохранении личного адреса:', error);
        return false;
    }
}

// Функция для удаления личного адреса
function removePersonalAddress(addressId) {
    try {
        const addresses = getPersonalAddresses();
        const filteredAddresses = addresses.filter(addr => addr.id !== addressId);
        ensureOrderState();
        window.__orderState.personalAddresses = filteredAddresses;
        console.log(`✅ Личный адрес ${addressId} удален`);
        return true;
    } catch (error) {
        console.error('Ошибка при удалении личного адреса:', error);
        return false;
    }
}

// Функция для очистки всех личных адресов
function clearPersonalAddresses() {
    try {
        ensureOrderState();
        window.__orderState.personalAddresses = [];
        console.log('✅ Все личные адреса очищены');
        return true;
    } catch (error) {
        console.error('Ошибка при очистке личных адресов:', error);
        return false;
    }
}

// Функция для валидации данных адреса
function validateAddressData(addressData) {
    const requiredFields = ['city', 'street', 'house'];
    const missingFields = requiredFields.filter(field => !addressData[field] || addressData[field].trim() === '');
    
    if (missingFields.length > 0) {
        console.error('❌ Отсутствуют обязательные поля:', missingFields);
        return false;
    }
    
    return true;
}

// Функция для сбора данных из формы добавления адреса
function collectAddressFormData() {
    const form = document.querySelector('#add-new-address-form-order');
    if (!form) {
        console.error('❌ Форма добавления адреса не найдена');
        return null;
    }
    
    const formData = new FormData(form);
    const addressData = {
        city: formData.get('city') || '',
        street: formData.get('street') || '',
        house: formData.get('house') || '',
        apartment: formData.get('apartment') || '',
        isPrivateHouse: formData.get('private-house') === 'on'
    };
    
    // Формируем полный адрес
    let fullAddress = `${addressData.street}, д. ${addressData.house}`;
    if (addressData.apartment) {
        fullAddress += `, кв. ${addressData.apartment}`;
    }
    if (addressData.isPrivateHouse) {
        fullAddress += ' (частный дом)';
    }
    
    addressData.fullAddress = fullAddress;
    
    return addressData;
}

// Функция для сохранения адреса из формы
function saveAddressFromForm() {
    const addressData = collectAddressFormData();
    if (!addressData) {
        return false;
    }
    
    if (!validateAddressData(addressData)) {
        return false;
    }
    
    const success = savePersonalAddress(addressData);
    if (success) {
        // Обновляем dropdown если он инициализирован
        if (window.updatePersonalAddressesDropdown) {
            window.updatePersonalAddressesDropdown();
        }
        
        // Закрываем модальное окно
        const modal = document.querySelector('[data-type="add-new-address"]');
        if (modal) {
            modal.setAttribute('data-modal-state', 'close');
        }
        
        // Очищаем форму
        const form = document.querySelector('#add-new-address-form-order');
        if (form) {
            form.reset();
        }
        
        console.log('✅ Адрес успешно сохранен и форма очищена');
    }
    
    return success;
}

// Функция для установки личного адреса в форму доставки
function setPersonalAddressToForm(address) {
    const deliveryAddressBlock = document.querySelector('.delivery__address');
    if (deliveryAddressBlock && address) {
        deliveryAddressBlock.innerHTML = `Адрес доставки: ${address.city}<br>Личный адрес: ${address.fullAddress}`;
        console.log(`✅ Установлен личный адрес: ${address.fullAddress}`);

        // Активируем способ доставки «До двери курьером» и соответствующий item-delivery
        const firstDeliveryRadio = document.querySelector('#delivery-way-1');
        if (firstDeliveryRadio) {
            // Гарантируем корректный тип доставки для валидации заказа
            firstDeliveryRadio.dataset.radio = 'courer';
            firstDeliveryRadio.checked = true;
        }

        const deliveryItems = document.querySelectorAll('.item-delivery');
        if (deliveryItems && deliveryItems.length > 0) {
            deliveryItems.forEach(item => item.classList.remove('active'));
            // Первый блок — «До двери курьером»
            deliveryItems[0].classList.add('active');
        }

        // Обновляем видимость карт/состояние интерфейса
        if (window.toggleMapsVisibility) {
            window.toggleMapsVisibility('delivery-way-1');
        }

        // Обновляем header первого dropdown внутри item-delivery (личные адреса)
        const deliveryDropdowns = document.querySelectorAll('.item-delivery .dropdown');
        const personalAddressesDropdown = deliveryDropdowns && deliveryDropdowns[0];
        if (personalAddressesDropdown) {
            const dropdownHeader = personalAddressesDropdown.querySelector('.dropdown__header__text');
            if (dropdownHeader) {
                dropdownHeader.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                <path d="M11.2111 1.65423C10.5179 1.03951 9.70243 0.57837 8.81834 0.301094C7.93425 0.0238169 7.00151 -0.0633302 6.08135 0.045374C4.46691 0.273565 2.99193 1.08509 1.93505 2.32666C0.878168 3.56823 0.312561 5.15386 0.345078 6.78402C0.355587 8.41038 0.953941 9.97807 2.02974 11.1978L5.78653 15.4937C5.9249 15.6527 6.09575 15.7801 6.28755 15.8675C6.47936 15.9548 6.68766 16 6.89841 16C7.10916 16 7.31746 15.9548 7.50927 15.8675C7.70107 15.7801 7.87192 15.6527 8.01029 15.4937L11.7671 11.1978C12.8429 9.97807 13.4412 8.41038 13.4517 6.78402V6.53132C13.4447 5.60612 13.2414 4.69295 12.8551 3.8522C12.4689 3.01145 11.9085 2.26228 11.2111 1.65423ZM12.1377 6.7756C12.1388 8.0931 11.6597 9.36584 10.79 10.3555L7.03318 14.6598C6.92368 14.7777 6.8226 14.7862 6.7131 14.6598L2.9563 10.3555C2.0866 9.36584 1.60745 8.0931 1.60857 6.7756C1.57642 5.45534 2.02925 4.16908 2.8814 3.16016C3.73356 2.15123 4.92594 1.4896 6.23297 1.30045C6.44899 1.28786 6.66555 1.28786 6.88157 1.30045C8.26986 1.30484 9.60042 1.85656 10.5845 2.83587C11.5685 3.81518 12.1266 5.14306 12.1377 6.53132V6.7756Z" fill="#414141" fill-opacity="0.56"/>
                <path d="M6.87261 3.37207C6.24787 3.37207 5.63716 3.55733 5.11771 3.90441C4.59826 4.2515 4.19339 4.74483 3.95431 5.32201C3.71524 5.8992 3.65268 6.53432 3.77456 7.14705C3.89644 7.75979 4.19728 8.32262 4.63904 8.76438C5.0808 9.20614 5.64363 9.50698 6.25637 9.62886C6.86911 9.75074 7.50422 9.68818 8.08141 9.44911C8.65859 9.21003 9.15192 8.80517 9.49901 8.28571C9.84609 7.76626 10.0314 7.15555 10.0314 6.53081C10.0314 5.69306 9.69856 4.88962 9.10618 4.29724C8.5138 3.70487 7.71036 3.37207 6.87261 3.37207ZM6.87261 8.42606C6.49777 8.42606 6.13134 8.3149 5.81967 8.10665C5.508 7.8984 5.26508 7.6024 5.12163 7.25609C4.97819 6.90978 4.94065 6.52871 5.01378 6.16107C5.08691 5.79343 5.26741 5.45573 5.53247 5.19067C5.79752 4.92562 6.13522 4.74511 6.50287 4.67198C6.87051 4.59885 7.25158 4.63639 7.59789 4.77983C7.9442 4.92328 8.2402 5.1662 8.44845 5.47787C8.6567 5.78954 8.76785 6.15597 8.76785 6.53081C8.76785 7.03346 8.56818 7.51552 8.21275 7.87095C7.85732 8.22638 7.37526 8.42606 6.87261 8.42606Z" fill="#414141" fill-opacity="0.56"/>
            </svg>
            ${address.city} - ${address.fullAddress}
          `;
            }
        }

        // Обновляем dataset формы заказа, чтобы валидация сразу прошла
        const orderForm = document.querySelector('#order-form');
        if (orderForm) {
            orderForm.dataset.address = address.fullAddress;
            orderForm.dataset.city_name = address.city;
            delete orderForm.dataset.cdek_order;
        }

        if (window.dispatchOrderValidate) {
            window.dispatchOrderValidate();
        }
    }
}

// Функция для инициализации обработчиков формы
function initPersonalAddressFormHandlers() {
    const form = document.querySelector('#add-new-address-form-order');
    if (!form) {
        console.log('❌ Форма добавления адреса не найдена');
        return;
    }
    
    // Обработчик отправки формы
    form.addEventListener('submit', function(e) {
        e.preventDefault();
        saveAddressFromForm();
    });
    
    // Обработчик кнопки "Добавить"
    const submitButton = form.querySelector('button[type="submit"], button[name="button"]');
    if (submitButton) {
        submitButton.addEventListener('click', function(e) {
            e.preventDefault();
            saveAddressFromForm();
        });
    }
    
    console.log('✅ Обработчики формы личных адресов инициализированы');
}

// Экспортируем функции
export {
    getPersonalAddresses,
    savePersonalAddress,
    removePersonalAddress,
    clearPersonalAddresses,
    validateAddressData,
    collectAddressFormData,
    saveAddressFromForm,
    setPersonalAddressToForm,
    initPersonalAddressFormHandlers
};

// Экспортируем в глобальную область для использования в других модулях
window.getPersonalAddresses = getPersonalAddresses;
window.savePersonalAddress = savePersonalAddress;
window.removePersonalAddress = removePersonalAddress;
window.clearPersonalAddresses = clearPersonalAddresses;
window.setPersonalAddressToForm = setPersonalAddressToForm;
window.saveAddressFromForm = saveAddressFromForm; 